export interface CropPreset {
  labelKey: string;
  width: number;
  height: number;
}

export interface CropSlot {
  presets: CropPreset[];
  // For slots pl-front renders without object-fit, where another ratio would stretch.
  lockedAspect?: number;
}

// Upper bound for a manually chosen size, mirrored by pl-back's saveFile.
export const MAX_CROP_SIZE = 2560;

// First preset = the size pl-back's saveFile forces for the slot when not cropped.
export type CropSlotName =
  | "banner"
  | "sectionImage"
  | "formImage"
  | "serviceCover"
  | "icon";

export const CROP_SLOTS: Record<CropSlotName, CropSlot> = {
  banner: {
    presets: [
      { labelKey: "imageCrop.presets.standard", width: 1280, height: 720 },
      { labelKey: "imageCrop.presets.bannerDesktop", width: 1440, height: 590 },
    ],
  },
  sectionImage: {
    presets: [
      { labelKey: "imageCrop.presets.standard", width: 1280, height: 720 },
      { labelKey: "imageCrop.presets.photo43", width: 1200, height: 900 },
    ],
  },
  formImage: {
    presets: [
      { labelKey: "imageCrop.presets.standard", width: 1280, height: 720 },
    ],
  },
  serviceCover: {
    presets: [
      { labelKey: "imageCrop.presets.square", width: 400, height: 400 },
      { labelKey: "imageCrop.presets.serviceCard", width: 700, height: 500 },
    ],
  },
  icon: {
    presets: [
      { labelKey: "imageCrop.presets.icon", width: 60, height: 60 },
      { labelKey: "imageCrop.presets.iconRetina", width: 120, height: 120 },
    ],
    lockedAspect: 1,
  },
};
